import {MaterialFilterSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/filter_section.types';
import {
  Divider,
  FilterFlyoutBoolean,
  FilterFlyoutGeneric,
} from '@aboutyou/ui-components';
import React from 'react';
import {
  getBooleanFilterData,
  handleBooleanFilter,
} from '../../shared/booleanFilterUtils';
import {useMaterialFilterSection} from '../../shared/useMaterialFilterSection';

type Props = {
  activeFilters: Map<string, Array<string> | undefined>;
  data: MaterialFilterSection;
  hide: VoidFunction;
  isOpen: boolean;
  open: VoidFunction;
  submit: VoidFunction;
  resetFilter: (slug: string) => void;
  setFilter: (filterData: {
    filterId: string;
    filterSection: string;
    filterSlug?: string;
  }) => void;
  renderInPortal?: boolean;
  enableFlyoutFilter: boolean;
};

export const FilterSectionMaterial: React.FC<Props> = ({
  activeFilters,
  hide,
  isOpen,
  open,
  data,
  submit,
  resetFilter,
  setFilter,
  renderInPortal,
  enableFlyoutFilter,
}) => {
  const {sustainableFilter, veganFilter} = data;
  const {
    handleMaterialClick,
    materialLabel,
    activeItemIds,
    materialSlug,
    normalizedMaterialValues,
  } = useMaterialFilterSection({
    data,
    activeFilters,
    setFilter,
  });

  const {
    active: sustainableFilterActive,
    label: sustainableFilterLabel,
    slug: sustainableFilterSlug,
  } = getBooleanFilterData({activeFilters, filter: sustainableFilter});

  const {
    active: veganFilterActive,
    label: veganFilterLabel,
    slug: veganFilterSlug,
  } = getBooleanFilterData({activeFilters, filter: veganFilter});

  return (
    <>
      {materialLabel && materialSlug && normalizedMaterialValues && (
        <FilterFlyoutGeneric
          activeItemIds={activeItemIds}
          hide={hide}
          isOpen={isOpen}
          submit={submit}
          items={normalizedMaterialValues}
          key={`filter-flyout-material-${materialSlug}`}
          label={materialLabel}
          onAttributeClick={handleMaterialClick}
          open={open}
          renderInPortal={renderInPortal}
          enableFlyoutFilter={enableFlyoutFilter}
        >
          {sustainableFilterLabel && sustainableFilterSlug && (
            <>
              <Divider />
              <FilterFlyoutBoolean
                active={sustainableFilterActive}
                data-testid="filterFlyoutSustainableToggle"
                label={sustainableFilterLabel}
                onToggle={() =>
                  handleBooleanFilter({
                    slug: sustainableFilterSlug,
                    isCurrentlyActive: sustainableFilterActive,
                    setFilter,
                    resetFilter,
                  })
                }
              />
            </>
          )}

          {veganFilterLabel && veganFilterSlug && (
            <>
              <Divider />
              <FilterFlyoutBoolean
                active={veganFilterActive}
                data-testid="filterFlyoutVeganToggle"
                label={veganFilterLabel}
                onToggle={() =>
                  handleBooleanFilter({
                    slug: veganFilterSlug,
                    isCurrentlyActive: veganFilterActive,
                    setFilter,
                    resetFilter,
                  })
                }
              />
            </>
          )}
        </FilterFlyoutGeneric>
      )}
    </>
  );
};
